export const parseJSON = <T>(value: string | null | undefined): T | null => {
  if (typeof value === 'string' && value !== null && value !== '') {
    try {
      return JSON.parse(value) as T;
    } catch (error) {
      console.error('Error parsing JSON:', error);
      return null;
    }
  }
  return null;
};
